import { render, staticRenderFns } from "./page-auth-callback.vue?vue&type=template&id=58f2464a&scoped=true"
import script from "./page-auth-callback.vue?vue&type=script&lang=js"
export * from "./page-auth-callback.vue?vue&type=script&lang=js"
import style0 from "./page-auth-callback.vue?vue&type=style&index=0&id=58f2464a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f2464a",
  null
  
)

export default component.exports